interface OptimizedImageProps {
  src: string;
  alt: string;
  width?: number;
  height?: number;
  className?: string;
  loading?: "lazy" | "eager";
}

/**
 * OptimizedImage — renders the source image with consistent loading/sizing props.
 *
 * Note 2026-05-27: This component previously emitted <picture> tags with
 * <source srcSet="...avif"> and <source srcSet="...webp"> entries. Those
 * companion files were never generated alongside the source .jpg/.png assets,
 * so every <picture> request 404'd on .avif and .webp before falling back to
 * the original — visible as broken images on the homepage feature cards.
 * Stripped the <source> tags. AVIF/WebP optimisation can be reintroduced
 * via a build-time image-processing step when companions actually exist.
 */
export const OptimizedImage = ({
  src,
  alt,
  width,
  height,
  className = "",
  loading = "lazy",
}: OptimizedImageProps) => {
  return (
    <img
      src={src}
      alt={alt}
      width={width}
      height={height}
      loading={loading}
      className={className}
    />
  );
};

export default OptimizedImage;
